<div class="dialog">

  <h1 mat-dialog-title>
    {{title}}
  </h1>

  <div mat-dialog-content>
    <p>{{message}}</p>
  </div>

  <div class="ftbtn-gr" mat-dialog-actions>
      <button class="ftbtn" mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
      <button class="ftbtn" mat-button (click)="onDismiss()">No</button>  
  </div>
</div>